import api from '@app/utils/api';
import qs from 'qs';

export const createEntity = (body) => {
  return api.post('/executive/entities/add', body);
};

export const updateEntity = (body) => {
  return api.post('/executive/entities/update', body);
};

export const fetchParentEntities = (body) => {
  return api.post('/executive/entities/list-parents', body);
};

export const fetchEntity = (params) => {
  return api.get(`/executive/entities/get?${qs.stringify(params)}`);
};

export const fetchEntitySummary = (params) => {
  return api.get(`/executive/entities/fetch-summary?${qs.stringify(params)}`);
};

export const fetchEntityActivities = (params) => {
  return api.get(
    `/executive/entities/fetch-activities?${qs.stringify(params)}`
  );
};

export const fetchEntityReporters = (entityId, params) => {
  return api.get(
    `/executive/entities/${entityId}/reporters?${qs.stringify(params)}`
  );
};

export const sendReporterInvite = (entityId, body) => {
  return api.post(
    `/executive/entities/${entityId}/reporters/send-invite`,
    body
  );
};
